import { AbstractParser } from "../../parser";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Gender, MaritalStatus, Person } from "src/app/ui/models/domains/pbm/Beneficiary/person";
import { Address } from "src/app/ui/models/domains/pbm/companies/address";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { parseBeneficiaryKey, parseCard } from "./beneficiary-parse-functions";

export class FindBeneficiaryBySocialNumberParser extends AbstractParser<Beneficiary | Dependent> {
  parse(payload: any): Beneficiary | Dependent {
    if (payload.IsHolder) {
      const beneficiary = new Beneficiary();
      payload.Active ? beneficiary.activateBeneficiary() : beneficiary.inactivateBeneficiary();
      beneficiary.setBeneficiaryKey(parseBeneficiaryKey(payload.BeneficiaryKey));
      beneficiary.setIsHolder(payload.IsHolder);
      beneficiary.setCard(parseCard(payload.Card));  
      if(payload.ParentBeneficiaryKey){
        beneficiary.setParentBeneficiaryKey(parseBeneficiaryKey(payload.ParentBeneficiaryKey));
      }
      this.parsePerson(payload, beneficiary);
      return beneficiary;
    } else {
      const dependent = new Dependent();
      payload.Active ? dependent.activate() : dependent.deactivate();
      dependent.setBeneficiaryKey(parseBeneficiaryKey(payload.BeneficiaryKey));
      dependent.setCard(parseCard(payload.Card));        
      this.parsePerson(payload, dependent);
      return dependent;
    }
  }

  private parsePerson(payload: any, person: Person) {
    person.setName(payload.Name);
    person.setSocialNumber(payload.SocialNumber);
    person.setBirthDate(payload.BirthDate ? payload.BirthDate : "");
    person.setEmail(payload.Email);
    person.setTelephone(payload.Telephone ? payload.Telephone : "");
    person.setMobile(payload.Mobile ? payload.Mobile : "");

    const personGender = new Gender();
    personGender.setGender(payload.Gender);
    person.setGender(personGender);

    const personMaritalStatus = new MaritalStatus();
    personMaritalStatus.setMaritalStatus(payload.MaritalStatus);
    person.setMaritalStatus(personMaritalStatus);

    const address = new Address();
    address.setStreet(payload.Address.Street);
    address.setNumber(payload.Address.Number);
    address.setComplement(payload.Address.Complement);
    address.setZipCode(payload.Address.ZipCode ? payload.Address.ZipCode : "");
    address.setDistrict(payload.Address.District);
    address.setCity(payload.Address.City ? payload.Address.City.trim() : "");
    address.setRegion(payload.Address.Region ? payload.Address.Region.trim() : "");
    person.setAddress(address);
  }
}
